<ng-container *ngIf="productLinks$ | async as productLinks else placeholder">
	<ng-container *ngIf="productLinks.length > 0">
		<article
			obg-m-common-banner
			*ngFor="let link of productLinks$ | async; trackBy: trackByLink"
			[banner]="link"
		></article>
	</ng-container>
</ng-container>
<ng-template #placeholder>
	<article obg-m-common-banner *ngFor="let placeholder of placeholders" placeholder></article>
</ng-template>
